import { defineMessages } from 'react-intl';

export const registrationCountryErrorMessages = defineMessages({
    title: {
        id: 'registration.invitation_country_error_title',
        defaultMessage: 'We are unable to update your sponsorship.',
        description:
            'Title of the error when an invitation comes from a user from another country',
    },
    subtitle: {
        id: 'registration.invitation_country_error_subtitle',
        defaultMessage:
            'You and the friend or family member that invited you must have the same country of residence. If you believe this is an error, please contact support.',
        description:
            'Subtitle of the error when an invitation comes from a user from another country',
    },
    upgradeSubtitle: {
        id: 'registration.upgrade_country_error_subtitle',
        defaultMessage:
            "This sponsorship isn't available in your country of residence. If you believe this is an error, please contact support.",
        description:
            'Subtitle of the error when a sponsorship upgrade is rejected because the country the user resides in is not covered',
    },
});
